import Vue from "vue/dist/vue.common.js";
import AppChart from "./components/AppChart";
import AppFaq from "./components/AppFaq";
import AppHeader from "./components/AppHeader";
import VideoModule from "./components/VideoModule";
import AppNews from "./components/AppNews";
import TableModule from "./components/TableModule";
import SliderModule from "./components/SliderModule";
import AppContact from "./components/AppContact";
import TeamModule from "./components/TeamModule";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);


import { VueHammer } from "vue2-hammer";

VueHammer.config.swipe = {
	direction: 6,
};

Vue.use(VueHammer);


VueHammer.config.swipe = {
	direction: 6,
};

import "@/scss/app.scss";

new Vue({
	el: "#app",
	delimiters: ["[[", "]]"],
	components: {
		AppChart,
		AppFaq,
		AppHeader,
		AppNews,
		TableModule,
		VideoModule,
		SliderModule,
		AppContact,
		TeamModule,
	},
	mounted() {
		this.triggerAnimation();
		this.boxesEnter()
		this.determineMobile()
		window.addEventListener("resize", this.handleResize);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.handleResize);
	},
	methods: {
		determineMobile() {
			this.$nextTick(() => {
				const windowWidth = window.innerWidth
				const windowHeight = window.innerHeight

				if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && windowWidth > windowHeight) {
					document.querySelector('.orientation').style.display = 'flex'
					document.querySelector('body').classList.add('neon_body')
				} else {
					document.querySelector('.orientation').style.display = 'none'
					document.querySelector('body').classList.remove('neon_body')
				}
			})
		},
		triggerAnimation() {
			const titles = document.querySelectorAll('h1[data-animation="fadeInContainer"]')

			let options = {
				rootMargin: "200px",
				threshold: 0
			}

			let observer = new IntersectionObserver(entries => {
				entries.forEach(enter => {
					if (enter.intersectionRatio > 0) {
						this.titleAnimation(enter.target)
						observer.unobserve(enter.target)
					}
				})
			}, options);

			titles.forEach(el => {
				observer.observe(el);
			})
		},
		titleAnimation(target) {
			let tl = null;

			if (tl) {
				tl.clear(true)
			} else {
				let tl = gsap.timeline({
					scrollTrigger: {
						trigger: target,
						start: "top-=50px bottom-=10%",
						end: "bottom-=50px bottom-=10%",
						scrub: 0.8
					}
				});

				tl
					.fromTo(target, { duration: 0.3, y: 50, autoAlpha: 0 }, { y: 0, autoAlpha: 1 })
					.fromTo(target.children[0], { duration: 0.3, y: 50, autoAlpha: 0 }, { y: 0, autoAlpha: 0.7 }, '-=0.25')
					.set(target.children[0], { clearProps: 'opacity,visibility,transform' })
			}
		},
		boxesEnter() {
			let tl = gsap.timeline({
				scrollTrigger: {
					trigger: '.boxes__item',
					start: "top+=100px bottom-=30%",
					end: "bottom-=50px bottom-=10%",
					scrub: 0.8
				}
			});
			tl
				.fromTo('.boxes__item__image', { y: 50, autoAlpha: 0 }, { y: 0, autoAlpha: 1 })
				.fromTo('.boxes__item__context', { y: 50, autoAlpha: 0 }, { y: 0, autoAlpha: 1 }, '-=0.25')
		},
		handleResize() {
			ScrollTrigger.refresh()
			this.determineMobile()
		}
	}
});
